import './dropdown.shared.css';import '../styles/components/ellipsis.css';import '../styles/components/state.css';import '../styles/components/resets.css';/* empty css                                                */
/* empty css                                               */
/* empty css                                                  */
/* empty css                                      */
//#region src/components/dropdown.shared.css.ts
var dropdownPositioner = "sf2fpj0";
var dropdownPopup = "sf2fpj3 sf2fpj2 sf2fpj1 _14zs3h0";
var dropdownSearchHeader = "sf2fpj4 _14zs3h0";
var dropdownHeader = "sf2fpj5 _14zs3h0";
var dropdownHeaderSearch = "sf2fpj6";
var dropdownBack = "sf2fpj7 _14zs3h0 _14zs3h1 _16pesku0";
var dropdownBackIcon = "sf2fpj8";
var dropdownList = "sf2fpj9 _14zs3h0";
var dropdownItemLabel = "sf2fpjb _1o5w3a90";
var dropdownItemIndicator = "sf2fpjc";
//#endregion
export { dropdownBack, dropdownBackIcon, dropdownHeader, dropdownHeaderSearch, dropdownItemIndicator, dropdownItemLabel, dropdownList, dropdownPopup, dropdownPositioner, dropdownSearchHeader };
